import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'
import { useTranslations } from '@npco/common-utils-translations'
import { EducationPanel } from '@npco/zeller-design-system'

import ItemManagementDesktop from 'assets/images/item-management-desktop.png'
import ItemManagementMobile from 'assets/images/item-management-mobile.png'
import { useIsMobileResolution } from 'hooks/useIsMobileResolution'
import { ROOT } from 'const/routes'

import { translations } from './EmptyState.i18n'

export const EmptyState = () => {
  const isMobileResolution = useIsMobileResolution()
  const t = useTranslations(translations)

  const navigate = useNavigate()

  const image = useMemo(() => {
    const source = isMobileResolution
      ? ItemManagementMobile
      : ItemManagementDesktop
    const width = isMobileResolution ? '343' : '377'
    return <img alt={t('alt')} src={source} width={width} />
  }, [isMobileResolution, t])

  return (
    <div data-testid="item-management-empty-state">
      <EducationPanel
        ctaPrimary={{
          text: t('ctaPrimaryText'),
          onClick: () =>
            navigate(ROOT.PORTAL.ITEM_MANAGEMENT.ITEMS.NEW.relative),
        }}
        ctaSecondary={{
          text: t('ctaSecondaryText'),
          onClick: () =>
            navigate(ROOT.PORTAL.ITEM_MANAGEMENT.ITEMS.IMPORT.relative),
        }}
        description={t('description')}
        image={image}
        items={[t('item1'), t('item2'), t('item3')]}
        title={t('title')}
      />
    </div>
  )
}
